{
  "title": "如何管理平台使用者",
  "description": "查詢使用者、查看其跨競賽角色關係，並視需要停權、恢復或強制登出。",
  "headings": ["你會完成什麼", "適用角色", "操作前確認", "操作步驟", "完成後", "常見問題"],
  "summary": "完成後，可依需要查到任何使用者的帳號狀態與角色關係，並可停權、恢復啟用或強制撤銷其所有登入 session。",
  "roleNote": "平台管理員",
  "prerequisites": ["具備平台使用者管理相關權限"],
  "pathLabel": "平台管理 → 使用者",
  "steps": [
    {
      "title": "1. 搜尋或瀏覽使用者",
      "description": "在使用者清單中依姓名、Email 等條件搜尋，清單為伺服器端分頁，不會一次載入全平台資料。"
    },
    {
      "title": "2. 查看使用者詳細資料",
      "description": "點入單一使用者可查看基本資料，以及該使用者在每一場競賽中的角色關係（例如在 A 競賽是學生、在 B 競賽是評審、在 C 競賽是主辦方管理員），三者會分開列出，不會合併顯示。"
    },
    {
      "title": "3a. 停權帳號",
      "description": "填寫停權原因（必填）後執行「停權」；系統會將帳號狀態改為停權並同時撤銷該使用者所有現有登入 session，過程為原子操作。若該使用者是平台上唯一一位啟用中的超級管理員，停權會被系統拒絕（409 錯誤），以避免平台失去所有超級管理員。"
    },
    {
      "title": "3b. 恢復帳號",
      "description": "對已停權的帳號執行「恢復」，原因欄位為選填；恢復不會自動重新登入，使用者需重新輸入帳密登入。"
    },
    {
      "title": "3c. 強制撤銷所有 Session",
      "description": "填寫原因後可單獨強制撤銷該使用者目前所有登入 session，而不改變其帳號狀態；常用於懷疑帳號遭盜用等情境。"
    }
  ],
  "afterward": [
    "停權後該使用者立即被登出所有裝置，且需管理員恢復後才能再次登入",
    "恢復啟用後帳號狀態改回正常，但不會自動重新登入",
    "停權／恢復／強制登出皆會寫入平台稽核紀錄；停權與強制登出必須填寫原因"
  ],
  "nextSteps": "若需要調整某使用者的平台超級管理員身分，請見「如何管理平台超級管理員」。",
  "faq": [
    {
      "q": "停權會刪除該使用者過去的投稿、評分或稽核紀錄嗎？",
      "a": "不會。停權只變更帳號狀態並撤銷登入 session，完全不觸碰投稿、指派、分數、結果或稽核歷史等既有資料。"
    },
    {
      "q": "為什麼我無法停權某個使用者？",
      "a": "最常見的原因是「最後一位啟用中超級管理員保護」機制：若該使用者是平台上唯一一位啟用中的超級管理員，停權請求會被拒絕，需先指定另一位超級管理員後才能停權原本這位。"
    },
    {
      "q": "恢復帳號需要填寫原因嗎？",
      "a": "不需要，恢復的原因欄位是選填；只有「停權」與「強制撤銷 Session」要求必填原因，因為兩者都是限制使用者存取的操作。"
    }
  ]
}
